export const BRAND_BLUE = '#2365ab';
export const DEEP_BLUE = '#163d6b';
export const SOFT_BLUE = '#dfeeff';
export const SKY_BLUE = '#5f97dd';

export function buildStyles({ isMobile, isTablet }) {
  return {
  bookShell: {
    maxWidth: 1380,
    margin: '0 auto',
    display: 'grid',
    gridTemplateRows: 'auto auto auto auto',
    gap: isMobile ? 14 : isTablet ? 18 : 24
  },
  topControlRow: {
    display: 'grid',
    gridTemplateColumns: isTablet ? '1fr' : '1fr auto',
    gap: isMobile ? 10 : 12,
    alignItems: 'center'
  },
  chapterDeck: {
    display: 'grid',
    gap: 8,
    minWidth: 0,
    padding: isMobile ? '10px 10px 8px' : '12px 12px 10px',
    borderRadius: isMobile ? 20 : 24,
    background: 'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(241,246,255,0.98) 100%)',
    border: '1px solid rgba(184, 204, 232, 0.9)',
    boxShadow: '0 18px 36px rgba(35, 101, 171, 0.08)',
    backdropFilter: 'blur(16px)'
  },
  chapterDeckHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: isMobile ? 'wrap' : 'nowrap'
  },
  chapterDeckKicker: {
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    color: '#6a86a8',
    marginBottom: 3
  },
  chapterDeckTitle: {
    fontSize: isMobile ? 14 : 15,
    fontWeight: 800,
    color: '#102a46'
  },
  heroBanner: {
    display: 'grid',
    gridTemplateColumns: isTablet ? '1fr' : '1.2fr 0.8fr',
    gap: isMobile ? 12 : 14,
    alignItems: 'stretch',
    borderRadius: isMobile ? 24 : 32,
    padding: isMobile ? '16px 14px' : '18px 22px',
    background: `linear-gradient(135deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 58%, ${SKY_BLUE} 150%)`,
    boxShadow: '0 26px 90px rgba(22, 61, 107, 0.22)',
    color: '#f8fbff',
    position: 'relative',
    overflow: 'hidden'
  },
  heroCopy: {
    position: 'relative',
    zIndex: 1
  },
  heroBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '5px 11px',
    borderRadius: 999,
    background: 'rgba(255,255,255,0.16)',
    border: '1px solid rgba(255,255,255,0.2)',
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
  },
  heroTitle: {
    margin: '10px 0 8px',
    fontSize: isMobile ? 'clamp(24px, 7vw, 30px)' : 'clamp(30px, 3.6vw, 42px)',
    lineHeight: 1.04
  },
  heroText: {
    margin: 0,
    fontSize: isMobile ? 13 : 14,
    lineHeight: 1.55,
    color: 'rgba(248,251,255,0.92)',
    maxWidth: 620
  },
  heroActions: {
    display: 'grid',
    alignContent: 'center',
    gap: 10,
    justifyItems: isTablet ? 'stretch' : 'end',
    width: '100%'
  },
  heroActionButton: {
    border: '1px solid rgba(255,255,255,0.24)',
    background: 'rgba(255,255,255,0.14)',
    color: '#f8fafc',
    borderRadius: 999,
    padding: isMobile ? '9px 12px' : '10px 14px',
    fontSize: isMobile ? 12 : 13,
    fontWeight: 800,
    letterSpacing: '0.02em',
    cursor: 'pointer',
    boxShadow: '0 14px 28px rgba(9, 30, 66, 0.18)',
    backdropFilter: 'blur(10px)',
    width: isTablet ? '100%' : 'auto',
    textAlign: 'center'
  },
  spreadCounter: {
    padding: '8px 12px',
    borderRadius: 14,
    background: 'linear-gradient(135deg, rgba(16, 42, 70, 0.96) 0%, rgba(35, 101, 171, 0.92) 100%)',
    border: '1px solid rgba(165, 205, 248, 0.26)',
    fontSize: 12,
    fontWeight: 700,
    color: '#dbeafe',
    boxShadow: '0 12px 24px rgba(16, 42, 70, 0.2)'
  },
  chapterRailWrap: {
    position: 'relative',
    minWidth: 0
  },
  chapterRailFadeLeft: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 24,
    background: 'linear-gradient(90deg, rgba(245,249,255,1) 0%, rgba(245,249,255,0) 100%)',
    pointerEvents: 'none',
    zIndex: -1,
    borderRadius: '18px 0 0 18px'
  },
  chapterRailFadeRight: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: 24,
    background: 'linear-gradient(270deg, rgba(245,249,255,1) 0%, rgba(245,249,255,0) 100%)',
    pointerEvents: 'none',
    zIndex: 1,
    borderRadius: '0 18px 18px 0'
  },
  chapterRail: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 6,
    minWidth: 0,
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingLeft: 2,
    paddingRight: 10,
    paddingBottom: 2,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none'
  },
  pdfActionButton: {
    border: '1px solid rgba(16, 56, 96, 0.14)',
    background: '#ffffff',
    color: DEEP_BLUE,
    borderRadius: 999,
    padding: isMobile ? '10px 12px' : '10px 16px',
    fontSize: isMobile ? 12 : 13,
    fontWeight: 800,
    letterSpacing: '0.01em',
    cursor: 'pointer',
    boxShadow: '0 12px 24px rgba(35, 101, 171, 0.08)',
    width: isTablet ? '100%' : 'auto',
    justifySelf: isTablet ? 'stretch' : 'end'
  },
  chapterPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexShrink: 0,
    gap: 6,
    padding: isMobile ? '6px 8px' : '6px 9px',
    borderRadius: 999,
    border: '1px solid rgba(184, 204, 232, 0.9)',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(241,246,255,0.92) 100%)',
    color: '#28486f',
    fontSize: isMobile ? 10 : 11,
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 12px 24px rgba(35, 101, 171, 0.08)',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  chapterPillActive: {
    background: `linear-gradient(135deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 100%)`,
    color: '#f8fbff',
    borderColor: 'rgba(22, 61, 107, 0.9)',
    boxShadow: '0 16px 34px rgba(22, 61, 107, 0.18)'
  },
  chapterPillNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: isMobile ? 16 : 18,
    height: isMobile ? 16 : 18,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.18)',
    fontSize: isMobile ? 8 : 9,
    fontWeight: 900
  },
  bookStage: {
    position: 'relative',
    padding: isMobile ? '4px 0 0' : isTablet ? '8px 0 0' : '12px 12px 0',
    perspective: 1800,
    isolation: 'isolate'
  },
  bookAura: {
    position: 'absolute',
    inset: '20px 5% auto',
    height: isMobile ? 120 : 180,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(35, 101, 171, 0.14) 0%, rgba(35, 101, 171, 0) 72%)',
    filter: 'blur(10px)'
  },
  bookSpine: {
    position: 'absolute',
    left: '50%',
    top: 22,
    bottom: 12,
    width: 34,
    transform: 'translateX(-50%)',
    borderRadius: 999,
    background: 'linear-gradient(180deg, rgba(8, 28, 52, 0.96) 0%, rgba(18, 57, 97, 0.98) 18%, rgba(35, 101, 171, 0.92) 52%, rgba(18, 57, 97, 0.98) 82%, rgba(8, 28, 52, 0.96) 100%)',
    border: '1px solid rgba(165, 205, 248, 0.22)',
    boxShadow: '0 12px 34px rgba(12, 41, 78, 0.24), inset 0 1px 0 rgba(255,255,255,0.16), inset 0 0 0 1px rgba(10, 29, 54, 0.24)',
    zIndex: 0
  },
  bookSpread: {
    position: 'relative',
    display: 'grid',
    gap: isMobile ? 14 : 18,
    alignItems: 'stretch',
    animationDuration: '420ms',
    animationTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
    animationFillMode: 'both'
  },
  bookPage: {
    position: 'relative',
    minHeight: isMobile ? '60vh' : isTablet ? '66vh' : '76vh',
    maxHeight: isMobile ? '68vh' : isTablet ? '72vh' : '78vh',
    overflow: 'hidden',
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr',
    gap: 12,
    padding: isMobile ? '16px 14px' : isTablet ? '18px 18px 16px' : '22px 22px 18px',
    borderRadius: isMobile ? 24 : 28,
    background: 'linear-gradient(180deg, #ffffff 0%, #fcfdff 45%, #f3f7ff 100%)',
    border: '1px solid rgba(191, 208, 232, 0.95)',
    boxShadow: '0 30px 60px rgba(15, 23, 42, 0.12), inset 0 1px 0 rgba(255,255,255,0.9)',
    zIndex: 1
  },
  pageInnerGlow: {
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    background: 'radial-gradient(circle at top right, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 28%), linear-gradient(180deg, rgba(35,101,171,0.04) 0%, rgba(35,101,171,0) 16%, rgba(15,23,42,0.03) 100%)',
    pointerEvents: 'none',
    zIndex: 0
  },
  pageInnerGlowCover: {
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    background: 'radial-gradient(circle at top right, rgba(255,255,255,0.32) 0%, rgba(255,255,255,0) 26%), linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 22%, rgba(8,28,52,0.14) 100%)',
    pointerEvents: 'none',
    zIndex: 0
  },
  pageCornerFold: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 62,
    height: 62,
    background: 'linear-gradient(135deg, rgba(223,238,255,0) 0%, rgba(223,238,255,0) 49%, rgba(223,238,255,0.98) 50%, rgba(198,220,247,0.98) 100%)',
    clipPath: 'polygon(100% 0, 0 0, 100% 100%)',
    opacity: 0.9,
    pointerEvents: 'none',
    zIndex: 0
  },
  bookPageCover: {
    background: `linear-gradient(160deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 52%, ${SKY_BLUE} 100%)`,
    border: '1px solid rgba(143, 187, 236, 0.34)',
    boxShadow: '0 34px 72px rgba(10, 35, 66, 0.28), inset 0 1px 0 rgba(255,255,255,0.18)',
    color: '#f8fbff'
  },
  bookPageLeft: {
    transformOrigin: 'right center'
  },
  bookPageRight: {
    transformOrigin: 'left center'
  },
  pageChromeTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    flexWrap: isMobile ? 'wrap' : 'nowrap',
    position: 'relative',
    zIndex: 1
  },
  pageEyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: isMobile ? '5px 10px' : '6px 12px',
    borderRadius: 999,
    background: SOFT_BLUE,
    color: DEEP_BLUE,
    fontSize: isMobile ? 10 : 11,
    fontWeight: 800,
    letterSpacing: '0.12em',
    textTransform: 'uppercase'
  },
  pageNumber: {
    fontSize: isMobile ? 11 : 12,
    fontWeight: 800,
    color: '#6b85a6',
    letterSpacing: '0.08em'
  },
  pageTitle: {
    margin: 0,
    fontSize: isMobile ? 22 : isTablet ? 24 : 28,
    lineHeight: 1.08,
    color: '#0f172a',
    position: 'relative',
    zIndex: 1
  },
  pageBody: {
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: isMobile ? 2 : 6,
    scrollbarGutter: 'stable',
    display: 'grid',
    alignContent: 'start',
    position: 'relative',
    zIndex: 1
  },
  pageBodyCover: {
    overflow: 'hidden',
    paddingRight: 0,
    alignContent: 'stretch',
    height: '100%'
  },
  pageStack: {
    display: 'grid',
    gap: 16
  },
  pageStackCompact: {
    display: 'grid',
    gap: 12
  },
  coverLeadCard: {
    borderRadius: isMobile ? 20 : 24,
    padding: isMobile ? 16 : 20,
    background: `linear-gradient(135deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 100%)`,
    color: '#eff6ff',
    boxShadow: '0 18px 40px rgba(22, 61, 107, 0.2)'
  },
  coverLeadLabel: {
    marginBottom: 10,
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#bfdbfe'
  },
  coverLeadText: {
    margin: '0 0 14px',
    fontSize: isMobile ? 14 : 15,
    lineHeight: isMobile ? 1.68 : 1.75,
    color: '#f8fbff'
  },
  coverPageShell: {
    position: 'relative',
    minHeight: '100%',
    display: 'grid',
    gridTemplateRows: 'auto auto auto auto auto 1fr',
    alignContent: 'start',
    gap: isMobile ? 12 : 18,
    padding: isMobile ? '4px 2px 8px' : '8px 6px 12px',
    color: '#f8fbff'
  },
  coverPageGlow: {
    position: 'absolute',
    inset: 'auto -18% -18% auto',
    width: isMobile ? 200 : 320,
    height: isMobile ? 200 : 320,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 72%)',
    pointerEvents: 'none'
  },
  coverPageTopline: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifySelf: 'start',
    padding: '6px 12px',
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.18)',
    background: 'rgba(255,255,255,0.12)',
    fontSize: isMobile ? 10 : 11,
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase'
  },
  coverPageBrand: {
    position: 'relative',
    fontSize: isMobile ? 16 : 18,
    fontWeight: 700,
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    color: 'rgba(219, 234, 254, 0.88)'
  },
  coverPageTitle: {
    position: 'relative',
    margin: 0,
    fontSize: isMobile ? 'clamp(28px, 8.5vw, 38px)' : isTablet ? 'clamp(38px, 6vw, 52px)' : 'clamp(48px, 5vw, 66px)',
    lineHeight: 0.98,
    letterSpacing: '-0.03em',
    maxWidth: 760,
    textWrap: 'balance'
  },
  coverPageText: {
    position: 'relative',
    margin: 0,
    maxWidth: 700,
    fontSize: isMobile ? 14 : isTablet ? 15 : 17,
    lineHeight: 1.7,
    color: 'rgba(239, 246, 255, 0.94)'
  },
  coverPageEditionRow: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8
  },
  coverPageEditionChip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: isMobile ? '7px 10px' : '8px 12px',
    borderRadius: 999,
    background: 'rgba(255,255,255,0.14)',
    border: '1px solid rgba(255,255,255,0.16)',
    color: '#eff6ff',
    fontSize: isMobile ? 11 : 12,
    fontWeight: 700,
    letterSpacing: '0.03em',
    backdropFilter: 'blur(10px)'
  },
  coverPageDivider: {
    position: 'relative',
    width: isMobile ? 84 : 128,
    height: 3,
    borderRadius: 999,
    background: 'linear-gradient(90deg, rgba(255,255,255,0.86) 0%, rgba(191,219,254,0.52) 100%)'
  },
  coverPageMetaGrid: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr' : 'repeat(3, minmax(0, 1fr))',
    gap: isMobile ? 8 : 10,
    alignSelf: 'end'
  },
  coverPageMetaCard: {
    borderRadius: isMobile ? 18 : 20,
    padding: isMobile ? '10px 11px' : isTablet ? '11px 12px' : '14px 14px',
    background: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.14)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
    backdropFilter: 'blur(8px)'
  },
  coverPageMetaLabel: {
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'rgba(219, 234, 254, 0.84)',
    marginBottom: 6
  },
  coverPageMetaValue: {
    fontSize: isMobile ? 13 : isTablet ? 14 : 15,
    fontWeight: 700,
    color: '#f8fbff'
  },
  bookNavRow: {
    display: 'grid',
    gridTemplateColumns: isTablet ? '1fr 1fr' : 'auto 1fr auto',
    gap: isMobile ? 8 : 10,
    alignItems: 'center',
    marginTop: isMobile ? 8 : 12,
    padding: isMobile ? '8px 10px' : '10px 12px',
    borderRadius: isMobile ? 18 : 20,
    background: 'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(243,247,255,0.98) 100%)',
    border: '1px solid rgba(184, 204, 232, 0.92)',
    boxShadow: '0 12px 26px rgba(35, 101, 171, 0.08)',
    position: 'relative',
    width: 'min(920px, 100%)',
    maxWidth: 920,
    justifySelf: 'center',
    boxSizing: 'border-box',
    backdropFilter: 'blur(16px)',
    marginBottom: '35px'
  },
  bookNavButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    minHeight: 38,
    minWidth: isTablet ? 0 : 132,
    border: '1px solid rgba(16, 56, 96, 0.9)',
    background: `linear-gradient(135deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 100%)`,
    color: '#f8fbff',
    borderRadius: 999,
    padding: isMobile ? '8px 10px' : '8px 14px',
    fontSize: isMobile ? 12 : 13,
    fontWeight: 800,
    cursor: 'pointer',
    boxShadow: '0 12px 22px rgba(22, 61, 107, 0.18), inset 0 1px 0 rgba(255,255,255,0.16)',
    letterSpacing: '0.01em',
    width: isTablet ? '100%' : 'auto'
  },
  bookNavButtonDisabled: {
    opacity: 0.45,
    background: 'linear-gradient(135deg, #7c94b1 0%, #93a9c4 100%)',
    borderColor: 'rgba(120, 143, 169, 0.95)',
    boxShadow: '0 10px 24px rgba(120, 143, 169, 0.16)',
    cursor: 'not-allowed'
  },
  bookNavHint: {
    textAlign: 'center',
    fontSize: isMobile ? 11 : 12,
    fontWeight: 700,
    color: '#557392',
    gridColumn: isTablet ? '1 / -1' : 'auto',
    order: isTablet ? 3 : 'initial',
    padding: isTablet ? '0 4px' : 0,
    lineHeight: 1.2,
    margin: isTablet ? '2px 0' : 0
  },
  bookNavArrow: {
    fontSize: 14,
    lineHeight: 1,
    fontWeight: 900,
    transform: 'translateY(-1px)'
  },
  bookNavButtonText: {
    whiteSpace: 'nowrap',
    lineHeight: 1
  },
  exportRoot: {
    position: 'absolute',
    left: '-20000px',
    top: 0,
    width: 794,
    padding: 0,
    background: '#ffffff',
    display: 'grid',
    gap: 0,
    pointerEvents: 'none'
  },
  exportPage: {
    width: 794,
    minHeight: 1123,
    boxSizing: 'border-box',
    overflow: 'hidden',
    borderRadius: 0,
    border: 'none',
    background: '#ffffff',
    padding: 28,
    boxShadow: 'none'
  },
  exportPageCover: {
    padding: 0,
    background: `linear-gradient(160deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 55%, ${SKY_BLUE} 100%)`
  },
  exportPageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginBottom: 12
  },
  exportEyebrow: {
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    color: BRAND_BLUE
  },
  exportPageNumber: {
    fontSize: 12,
    fontWeight: 800,
    color: '#64748b'
  },
  exportPageTitle: {
    margin: '0 0 18px',
    fontSize: 28,
    lineHeight: 1.1,
    color: '#0f172a'
  },
  exportCoverShell: {
    minHeight: 1123,
    boxSizing: 'border-box',
    display: 'grid',
    alignContent: 'space-between',
    gap: 28,
    padding: '84px 72px 72px',
    color: '#f8fbff'
  },
  exportCoverOverline: {
    display: 'inline-flex',
    alignItems: 'center',
    justifySelf: 'start',
    padding: '8px 14px',
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.18)',
    background: 'rgba(255,255,255,0.12)',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.18em',
    textTransform: 'uppercase'
  },
  exportCoverBrand: {
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: '0.26em',
    textTransform: 'uppercase',
    color: 'rgba(219, 234, 254, 0.88)'
  },
  exportCoverTitle: {
    margin: 0,
    maxWidth: 560,
    fontSize: 62,
    lineHeight: 0.98,
    letterSpacing: '-0.04em'
  },
  exportCoverText: {
    margin: 0,
    maxWidth: 560,
    fontSize: 20,
    lineHeight: 1.7,
    color: 'rgba(239, 246, 255, 0.96)'
  },
  exportCoverDivider: {
    width: 160,
    height: 4,
    borderRadius: 999,
    background: 'linear-gradient(90deg, rgba(255,255,255,0.92) 0%, rgba(191,219,254,0.52) 100%)'
  },
  exportCoverFooter: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 12,
    alignItems: 'stretch',
    marginTop: 'auto'
  },
  exportCoverFooterItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 64,
    padding: '12px 16px',
    borderRadius: 18,
    border: '1px solid rgba(255,255,255,0.14)',
    background: 'rgba(255,255,255,0.1)',
    color: '#f8fbff',
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center'
  },
  copy: {
    margin: '0 0 14px',
    fontSize: isMobile ? 14 : 15,
    lineHeight: isMobile ? 1.68 : 1.75,
    color: '#334155'
  },
  sectionCard: {
    borderRadius: isMobile ? 22 : 28,
    background: '#ffffff',
    border: '1px solid rgba(148, 163, 184, 0.18)',
    boxShadow: '0 18px 44px rgba(15, 23, 42, 0.08)',
    padding: isMobile ? '20px 16px' : '28px clamp(18px, 3vw, 32px)'
  },
  grid2: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: 16
  },
  grid3: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: 16
  },
  twoCols: {
    display: 'grid',
    gridTemplateColumns: isTablet ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: 18,
    alignItems: 'start'
  },
  infoCard: {
    borderRadius: isMobile ? 18 : 22,
    background: 'linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)',
    border: '1px solid rgba(184, 204, 232, 0.92)',
    padding: isMobile ? 16 : 20,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.72)'
  },
  roleCard: {
    display: 'grid',
    gridTemplateColumns: isTablet ? '1fr' : 'minmax(240px, 0.9fr) 1.1fr',
    gap: isMobile ? 14 : 20,
    alignItems: 'start',
    borderRadius: isMobile ? 18 : 22,
    background: 'linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)',
    border: '1px solid rgba(184, 204, 232, 0.92)',
    padding: isMobile ? 16 : 22
  },
  bulletCard: {
    display: 'flex',
    gap: 10,
    alignItems: 'flex-start'
  },
  bulletDot: {
    width: 9,
    height: 9,
    marginTop: 7,
    borderRadius: '50%',
    background: BRAND_BLUE,
    flexShrink: 0,
    boxShadow: '0 0 0 6px rgba(35, 101, 171, 0.14)'
  },
  cardTitle: {
    margin: '0 0 10px',
    fontSize: isMobile ? 17 : 19,
    color: '#0f172a'
  },
  cardTag: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 11px',
    borderRadius: 999,
    background: SOFT_BLUE,
    color: DEEP_BLUE,
    fontSize: isMobile ? 11 : 12,
    fontWeight: 800,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    marginBottom: 14
  },
  credentialRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: isMobile ? 'column' : 'row',
    gap: 12,
    marginBottom: 10,
    paddingBottom: 10,
    borderBottom: '1px solid rgba(226, 232, 240, 0.9)',
    fontSize: isMobile ? 13 : 14,
    color: '#475569'
  },
  orderedList: {
    margin: 0,
    paddingLeft: 20,
    color: '#334155',
    lineHeight: 1.8,
    fontSize: isMobile ? 14 : 15
  },
  list: {
    margin: 0,
    paddingLeft: 20,
    color: '#334155',
    lineHeight: 1.8,
    fontSize: isMobile ? 14 : 15
  },
  highlightPanel: {
    borderRadius: isMobile ? 18 : 22,
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    color: '#e2e8f0',
    padding: isMobile ? 16 : 22,
    boxShadow: '0 18px 36px rgba(15, 23, 42, 0.18)'
  },
  highlightPanelAlt: {
    borderRadius: isMobile ? 18 : 22,
    background: `linear-gradient(135deg, ${SOFT_BLUE} 0%, #c9dcf7 100%)`,
    color: '#1d3d67',
    padding: isMobile ? 16 : 22,
    border: '1px solid rgba(35, 101, 171, 0.18)'
  },
  highlightTitle: {
    marginBottom: 10,
    fontSize: isMobile ? 15 : 16,
    fontWeight: 800,
    color: 'inherit'
  },
  highlightPanelText: {
    margin: '0 0 14px',
    fontSize: isMobile ? 14 : 15,
    lineHeight: isMobile ? 1.68 : 1.75,
    color: 'inherit'
  },
  flowCard: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '56px 1fr',
    gap: isMobile ? 12 : 16,
    alignItems: 'start',
    padding: isMobile ? 16 : 18,
    borderRadius: isMobile ? 18 : 22,
    border: '1px solid rgba(184, 204, 232, 0.8)',
    background: 'linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)'
  },
  flowIndex: {
    width: isMobile ? 48 : 56,
    height: isMobile ? 48 : 56,
    borderRadius: 18,
    background: `linear-gradient(135deg, ${BRAND_BLUE} 0%, ${DEEP_BLUE} 100%)`,
    color: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: isMobile ? 18 : 22,
    fontWeight: 900,
    boxShadow: '0 18px 30px rgba(35, 101, 171, 0.2)'
  },
  noteRow: {
    display: 'grid',
    gridTemplateColumns: '10px 1fr',
    gap: 12,
    alignItems: 'start',
    padding: isMobile ? '12px 14px' : '14px 16px',
    borderRadius: isMobile ? 16 : 18,
    background: '#f6f9ff',
    border: '1px solid rgba(214, 226, 243, 0.92)'
  },
  noteRowSoft: {
    display: 'grid',
    gridTemplateColumns: '10px 1fr',
    gap: 12,
    alignItems: 'start',
    padding: isMobile ? '11px 12px' : '12px 14px',
    borderRadius: isMobile ? 14 : 16,
    background: '#f6f9ff',
    border: '1px solid rgba(214, 226, 243, 0.88)'
  },
  noteAccent: {
    width: 10,
    height: 10,
    marginTop: 8,
    borderRadius: '50%',
    background: BRAND_BLUE
  },
  noteAccentSoft: {
    width: 10,
    height: 10,
    marginTop: 8,
    borderRadius: '50%',
    background: SKY_BLUE
  },
  lifecycleCard: {
    display: 'grid',
    gridTemplateColumns: isTablet ? '1fr' : '220px 1fr',
    gap: isMobile ? 14 : 18,
    alignItems: 'start',
    borderRadius: isMobile ? 18 : 22,
    border: '1px solid rgba(184, 204, 232, 0.82)',
    background: 'linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)',
    padding: isMobile ? 16 : 20
  },
  lifecycleMeta: {
    borderRadius: isMobile ? 16 : 18,
    background: `linear-gradient(135deg, ${DEEP_BLUE} 0%, ${BRAND_BLUE} 100%)`,
    color: '#f8fafc',
    padding: isMobile ? 14 : 18,
    boxShadow: '0 16px 28px rgba(35, 101, 171, 0.2)'
  },
  lifecycleOwnerLabel: {
    fontSize: isMobile ? 10 : 11,
    fontWeight: 800,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    opacity: 0.86,
    marginBottom: 8
  },
  lifecycleOwnerValue: {
    fontSize: isMobile ? 17 : 20,
    fontWeight: 800,
    lineHeight: 1.25
  },
  faqCard: {
    borderRadius: isMobile ? 18 : 20,
    padding: isMobile ? 16 : 20,
    background: 'linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)',
    border: '1px solid rgba(214, 226, 243, 0.95)'
  }
  };
}
